export default "__VITE_ASSET__N4Lcy3Ke__"